// copy to config.ts

import { ApiConfigType } from "./consts/dataTypes";

export const apiConfig : ApiConfigType = {
    apiUrl: 'https://api.eazyreadapp.com/',
};